import styled from 'styled-components';

import { IOffice } from '../../common/model/office.model';
import { GalleryButton, ImageCarousel } from '../shared';

type Props = {
  office: IOffice;
  onGalleryShow: () => void;
  className?: string;
};

const PhotosSection: React.FC<Props> = ({
  office,
  onGalleryShow,
  className,
}) => {
  return (
    <div className={className}>
      <ImageCarousel
        pictureUrls={office.imageUrls}
        buttons={[
          <GalleryButton key="gallery-button" onClick={onGalleryShow} />,
        ]}
      />
    </div>
  );
};

export default styled(PhotosSection)`
  height: 100%;
`;
